const validateCurrency = (prods, currency) => {
  return prods?.map((item) => {
    if (!item.currency) {
      return {
        ...item,
        currency: currency,
      };
    }
    return item;
  });
};

const formatPrice = (price) => {
  let priceStr = price.toString();

  if (!priceStr) {
    console.warn('Empty price, defaulting to 0.00');
    return '0.00';
  }

  if (/^\d+$/.test(priceStr)) {
    priceStr += '.00';
  } else {
    priceStr = priceStr.replace(',', '.');
  }

  const formattedPrice = parseFloat(priceStr).toFixed(2);

  if (isNaN(formattedPrice)) {
    console.warn('Invalid price format, defaulting to 0.00');
    return '0.00';
  }

  return formattedPrice;
}

export const parseProductsForNosto = (products, currency) => {
  let parsedProds = [];
  validateCurrency(products, currency)?.map((product) => {
    const { projectSpecificData, variant, count, currency, price, name } =
      product || {};
    const unit_price = formatPrice(price / 100);
    const { original } = projectSpecificData || {};

    parsedProds.push({
      product_id: original?.productId,
      sku_id: variant?.sku,
      quantity: count,
      price_currency_code: currency || 'AUD',
      unit_price,
      name
    });
    return parsedProds;
  });
  return parsedProds;
};
